export const SET_TAX_LOSSES = 'SET_TAX_LOSSES'
export const SET_TAX_LOSS = 'SET_TAX_LOSS'
export const REMOVE_TAX_LOSS = 'REMOVE_TAX_LOSS'
